import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  constructor() { }
  DesiredCreditLimitValidation(minValue: number, maxValue: number, isDesiredCreditLimit=false) {

    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value == null || control.value == "") {
        return null;
      }
      let enteredValue = control.value;
      let enteredValueNum = Number(enteredValue.replace(',', ''));
      if (control.value.match(/^(\d?\d?\d(,\d\d\d)*|\d+)(\.\d\d)?$/)) {
        if (enteredValueNum >= minValue) {
          if (enteredValueNum <= maxValue) {
            return null;
          }
          else {
            return { 'moreThanMax': true };
          }

        }
        else {
          if(!isDesiredCreditLimit) {
            return { 'lessThanMin': true };
          }    
        }

      } else {
        return { 'invalidcurrency': true };
      }

    };

  }

  NetIncomeValidator(minValue:number, maxValue:number){
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value == null || control.value == "") {
        return null;
      }
      let enteredValue = control.value;
      let enteredValueNum = Number(enteredValue.replace(',', ''));
      if (control.value.match(/^(\d?\d?\d(,\d\d\d)*|\d+)(\.\d\d)?$/)) {
        if (enteredValueNum >= minValue) {
          if (enteredValueNum <= maxValue) {
            return null;
          }
          else {
            return { 'moreThanMax': true };
          }

        }
        else {
          return { 'lessThanMin': true };
        }

      } else {
        return { 'invalidcurrency': true };
      }

    };
  }

}
